<template>
  <v-container fluid :class="containerClasses">
    <v-row class="ma-0 analytics-row">
      <v-col cols="12" class="d-flex flex-column analytics-sidebar"
        :class="{ 'analytics-sidebar--collapsed': sidebarRecolhidaAtiva }" :style="sidebarStyle">
        <div class="d-flex align-center justify-space-between mb-4 analytics-sidebar__header">
          <div class="d-flex align-center">
            <v-btn icon color="#0B7285" class="analytics-sidebar__toggle" :disabled="modoEdicao"
              :title="sidebarToggleLabel" :aria-label="sidebarToggleLabel" @click="alternarSidebar">
              <v-icon :class="sidebarToggleIconClass">{{ sidebarToggleIcon }}</v-icon>
            </v-btn>

            <h3 v-if="!sidebarRecolhidaAtiva" class="text-h6 color-primary mb-0">
              {{ texts.relatorios }}
            </h3>
          </div>

          <v-btn v-if="modoEdicao && !sidebarRecolhidaAtiva" color="#0B7285" dark small @click="abrirDialogUpload()">
            <v-icon left>add</v-icon> Novo
          </v-btn>
        </div>

        <div class="analytics-sidebar__content">
          <div v-if="loadingLista" class="text-center mt-4">
            <v-progress-circular indeterminate color="#0B7285"></v-progress-circular>
          </div>

          <v-list v-else-if="!sidebarRecolhidaAtiva" dense nav class="pa-0">
            <v-list-item v-for="relatorio in listaRelatorios" :key="relatorio.nome"
              :class="{ 'v-list-item--active selected-item': selecionado && selecionado.nome === relatorio.nome }"
              @click="selecionarRelatorio(relatorio)">
              <v-list-item-content>
                <v-list-item-title class="text-subtitle-1">{{ relatorio.titulo || relatorio.nome }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="flex-row align-center" v-if="modoEdicao">
                <v-btn icon small color="#0B7285" class="mr-1" :title="texts.baixarArquivo"
                  :aria-label="texts.baixarArquivo" @click.stop="baixarRelatorio(relatorio)">
                  <v-icon small>download</v-icon>
                </v-btn>

                <v-btn icon small color="#0B7285" class="mr-1" @click.stop="abrirDialogSubstituir(relatorio)"
                  :title="texts.substituirRelatorio">
                  <v-icon small>edit</v-icon>
                </v-btn>

                <v-btn icon small color="#0B7285" @click.stop="abrirDialogExcluir(relatorio)">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="listaRelatorios.length === 0">
              <v-list-item-content>
                <v-list-item-subtitle>{{ texts.nenhumRelatorio }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div v-else class="d-flex flex-column align-center analytics-sidebar__mini-list">
            <v-tooltip v-for="relatorio in listaRelatorios" :key="relatorio.nome" right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon large class="mb-2 analytics-sidebar__mini-item"
                  :class="{ 'analytics-sidebar__mini-item--selected': selecionado && selecionado.nome === relatorio.nome }"
                  v-bind="attrs" v-on="on" @click="selecionarRelatorio(relatorio)">
                  <v-icon :color="selecionado && selecionado.nome === relatorio.nome ? '#0B7285' : 'grey darken-1'">
                    description
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ relatorio.titulo || relatorio.nome }}</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Botão de download do Manual IA temporariamente desabilitado.
        <div v-if="modoEdicao" class="mt-4">
          <v-btn
            v-if="!sidebarRecolhidaAtiva"
            block
            outlined
            color="#0B7285"
            @click="baixarManual"
          >
            <v-icon left>download</v-icon> Download Manual IA
          </v-btn>

          <v-tooltip v-else right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                color="#0B7285"
                class="analytics-sidebar__mini-item"
                v-bind="attrs"
                v-on="on"
                @click="baixarManual"
              >
                <v-icon>download</v-icon>
              </v-btn>
            </template>
            <span>{{ texts.downloadManual }}</span>
          </v-tooltip>
        </div>
        -->
      </v-col>

      <v-col cols="12" class="d-flex flex-column pa-0 analytics-viewer" :style="viewerStyle">
        <div v-if="!selecionado" class="d-flex justify-center align-center analytics-empty-state">
          <div class="text-center analytics-empty-state__content">
            <v-icon large color="grey lighten-1">bar_chart</v-icon>
            <h2 class="mt-2 text-h5 font-weight-light">Analytics</h2>
            <p>{{ texts.selecioneRelatorio }}</p>
          </div>
        </div>

        <div v-else class="analytics-frame-shell">
          <div v-if="loadingHtml && !htmlAtual" class="loading-overlay">
            <v-progress-circular indeterminate color="#0B7285" size="64"></v-progress-circular>
          </div>

          <iframe ref="iframeRelatorio" :srcdoc="viewerSrcdoc" sandbox="allow-scripts allow-downloads"
            @load="onIframeLoad" frameborder="0" class="analytics-iframe"></iframe>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUpload" max-width="720">
      <v-card>
        <v-card-title class="headline analytics-dialog__title">
          {{ formData.isSubstituicao ? texts.substituirRelatorio : texts.novoRelatorio }}
        </v-card-title>

        <v-card-text>
          <v-form ref="formUpload" v-model="validForm">
            <p v-if="formData.isSubstituicao" class="text-caption mb-3 red--text">
              {{ texts.textoSubstituicao }}
            </p>

            <p v-else class="text-caption mb-3">
              {{ texts.textoNovoRelatorio }}
            </p>

            <v-btn-toggle v-model="uploadMode" mandatory class="mb-4 analytics-upload-toggle" color="#0B7285"
              @change="tratarSelecaoAbaIA">
              <v-btn small value="arquivo">
                <v-icon left small>description</v-icon> {{ texts.arquivo }}
              </v-btn>
              <v-btn small value="texto">
                <v-icon left small>code</v-icon> {{ texts.colarHtml }}
              </v-btn>
              <v-btn small value="ia">
                <v-icon left small>smart_toy</v-icon> {{ formData.isSubstituicao ? 'Editar com IA' : 'Criar com IA' }}
              </v-btn>
            </v-btn-toggle>

            <template v-if="uploadMode === 'ia'">
              <div class="d-flex flex-column align-center justify-center pa-4 mt-2 mb-4 dashed-border">
                <v-icon size="48" color="#0B7285" class="mb-2">smart_toy</v-icon>
                <h3 class="mb-2 text-center" style="color: #0b7285">Assistente de Relatórios IA</h3>
                <p class="text-center grey--text mb-4">
                  Crie ou modifique relatórios interagindo com Chat.
                </p>
                <v-btn color="#0B7285" dark @click="abrirChatIA">
                  <v-icon left>chat</v-icon> Abrir Assistente
                </v-btn>
              </div>
            </template>
            <template v-else>
              <v-file-input v-if="uploadMode === 'arquivo'" v-model="formData.arquivo" accept=".html"
                :label="texts.labelArquivo" :rules="[v => !!v || texts.arquivoObrigatorio]" required outlined dense
                prepend-icon="description"></v-file-input>

              <v-textarea v-else-if="uploadMode === 'texto'" v-model="formData.htmlTexto" auto-grow rows="12" outlined
                no-resize :label="texts.labelColarHtml"
                :rules="[v => !!(v && v.trim()) || texts.coleHtml]"></v-textarea>
            </template>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogUpload = false">{{ texts.cancelar }}</v-btn>
          <v-btn v-if="uploadMode !== 'ia'" color="#0B7285" dark @click="salvarUpload" :loading="salvandoUpload"
            :disabled="!validForm">{{ texts.salvar }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <chatIA v-model="dialogChatIA" :modo="chatIAModo" :htmlInicial="chatIAHtmlInicial"
      :tituloRelatorio="chatIATituloRelatorio" :nomeOriginal="chatIANomeOriginal" :jsonDados="jsonDados"
      @salvo="onChatIASalvo" />

    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card>
        <v-card-title class="headline">{{ texts.confirmarExclusao }}</v-card-title>
        <v-card-text>
          {{ texts.confirmarExclusaoPrefixo }} <strong>{{ relatorioParaExcluir ? (relatorioParaExcluir.titulo ||
            relatorioParaExcluir.nome) : '' }}</strong>?
          {{ texts.confirmarExclusaoSufixo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogExcluir = false">{{ texts.cancelar }}</v-btn>
          <v-btn color="red darken-1" text @click="confirmarExclusao" :loading="excluindo">{{ texts.excluir }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { urlApi, showError } from "@/global";
import { fetchManualContent } from "./prompts/manual-relatorios";
import { clearIframePayloadSyncTimer, scheduleIframePayloadSync } from "./iframePayloadSync";
import {
  createIframeReadyBootstrap,
  IFRAME_READY_MESSAGE_TYPE,
  injectScriptIntoHtml
} from "./iframeReadyBridge";
import chatIA from "./chatIA.vue";

export default {
  name: "painelAnalytics",
  components: { chatIA },
  props: {
    modoEdicao: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jsonDados: null,
      listaRelatorios: [],
      selecionado: null,
      htmlAtual: "",
      iframeCarregado: false,
      iframeProntoParaDados: false,
      iframeRenderToken: 0,
      reenvioDadosTimer: null,
      reenvioDadosSequencia: 0,
      carregamentoRelatorioToken: 0,
      sidebarRecolhida: false,
      viewportWidth: typeof window !== "undefined" ? window.innerWidth : 1280,

      loadingLista: true,
      loadingHtml: false,

      dialogUpload: false,
      validForm: false,
      salvandoUpload: false,
      uploadMode: "arquivo",
      formData: {
        arquivo: null,
        htmlTexto: "",
        isSubstituicao: false,
        nomeOriginal: "",
        tituloOriginal: "",
      },

      dialogExcluir: false,
      excluindo: false,
      relatorioParaExcluir: null,

      dialogChatIA: false,
      chatIAModo: 'criar',
      chatIAHtmlInicial: '',
      chatIATituloRelatorio: '',
      chatIANomeOriginal: '',
    };
  },
  computed: {
    containerClasses() {
      return {
        "pa-4": true,
        "analytics-container": true,
        "analytics-container--fullscreen": this.fullscreen,
        "pt-16": !this.fullscreen,
        "mt-10": !this.fullscreen,
      };
    },
    isDesktop() {
      return this.viewportWidth >= 960;
    },
    sidebarRecolhidaAtiva() {
      return this.isDesktop && this.sidebarRecolhida;
    },
    sidebarColMd() {
      return this.sidebarRecolhidaAtiva ? 1 : 3;
    },
    viewerColMd() {
      return this.sidebarRecolhidaAtiva ? 11 : 9;
    },
    sidebarToggleIcon() {
      return "menu_open";
    },
    sidebarToggleIconClass() {
      return {
        "analytics-sidebar__toggle-icon": true,
        "analytics-sidebar__toggle-icon--collapsed": this.sidebarRecolhidaAtiva,
      };
    },
    sidebarToggleLabel() {
      return this.sidebarRecolhidaAtiva ? "Expandir menu de relatórios" : "Recolher menu de relatórios";
    },
    sidebarStyle() {
      if (!this.isDesktop) return null;

      const width = this.sidebarRecolhidaAtiva ? 56 : 340;

      return {
        flex: `0 0 ${width}px`,
        width: `${width}px`,
        maxWidth: `${width}px`,
      };
    },
    viewerStyle() {
      if (!this.isDesktop) return null;

      const sidebarWidth = this.sidebarRecolhidaAtiva ? 56 : 340;

      return {
        flex: "1 1 0",
        width: `calc(100% - ${sidebarWidth}px)`,
        maxWidth: `calc(100% - ${sidebarWidth}px)`,
      };
    },
    texts() {
      return {
        relatorios: "Relat\u00f3rios",
        nenhumRelatorio: "Nenhum relat\u00f3rio encontrado",
        selecioneRelatorio: "Selecione um relat\u00f3rio no menu ao lado.",
        downloadManual: "Download Manual IA",
        substituirRelatorio: "Substituir Relat\u00f3rio",
        novoRelatorio: "Novo Relat\u00f3rio",
        textoSubstituicao: "O relat\u00f3rio selecionado ser\u00e1 substitu\u00eddo pelo novo HTML.",
        textoNovoRelatorio: "O nome interno do arquivo ser\u00e1 gerado automaticamente pelo sistema.",
        arquivo: "Arquivo",
        colarHtml: "Colar HTML",
        labelArquivo: "Arquivo HTML do relat\u00f3rio",
        arquivoObrigatorio: "Arquivo obrigat\u00f3rio",
        labelColarHtml: "Cole o HTML completo do relat\u00f3rio",
        coleHtml: "Cole o HTML do relat\u00f3rio",
        cancelar: "Cancelar",
        salvar: "Salvar",
        baixarArquivo: "Baixar HTML",
        confirmarExclusao: "Confirmar exclus\u00e3o?",
        confirmarExclusaoPrefixo: "Tem certeza de que deseja excluir o relat\u00f3rio",
        confirmarExclusaoSufixo: "Esta a\u00e7\u00e3o n\u00e3o pode ser desfeita. Se preferir, cancele e baixe o arquivo antes de excluir para manter uma c\u00f3pia de segurança.",
        excluir: "Excluir",
        toastSalvo: "Relat\u00f3rio salvo com sucesso!",
        toastExcluido: "Relat\u00f3rio exclu\u00eddo com sucesso!",
      };
    },
    viewerSrcdoc() {
      if (!this.htmlAtual) return "";

      return injectScriptIntoHtml(
        this.htmlAtual,
        createIframeReadyBootstrap({
          origin: "painelAnalytics-viewer-ready",
          token: this.iframeRenderToken,
        })
      );
    },
  },
  watch: {
    jsonDados() {
      this.agendarEnvioDadosParaIframe();
    },
    modoEdicao: {
      immediate: true,
      handler(val) {
        if (val) {
          this.sidebarRecolhida = false;
        }
      },
    },
    uploadMode() {
      if (this.$refs.formUpload) {
        this.$nextTick(() => this.$refs.formUpload.resetValidation());
      }
    },
  },
  mounted() {
    this.atualizarViewport();
    window.addEventListener("resize", this.atualizarViewport);
    window.addEventListener("message", this.handleWindowMessage);
    this.carregarDadosSistema();
    this.carregarListaRelatorios();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.atualizarViewport);
    window.removeEventListener("message", this.handleWindowMessage);
    clearIframePayloadSyncTimer(this, "reenvioDadosTimer", "reenvioDadosSequencia");
  },
  methods: {
    atualizarViewport() {
      const larguraAnterior = this.viewportWidth;
      this.viewportWidth = window.innerWidth;

      if (!this.isDesktop) {
        this.sidebarRecolhida = false;
      }

      if (
        larguraAnterior !== this.viewportWidth
        && this.htmlAtual
        && this.iframeCarregado
        && this.iframeProntoParaDados
      ) {
        this.agendarEnvioDadosParaIframe();
      }
    },

    alternarSidebar() {
      if (!this.isDesktop || this.modoEdicao) return;
      this.sidebarRecolhida = !this.sidebarRecolhida;
      if (this.htmlAtual) {
        this.$nextTick(() => {
          this.agendarEnvioDadosParaIframe();
        });
      }
    },

    criarNomeInternoRelatorio() {
      const agora = new Date();
      const pad = (valor, tamanho = 2) => String(valor).padStart(tamanho, "0");

      return `relatorio_${agora.getFullYear()}${pad(agora.getMonth() + 1)}${pad(agora.getDate())}_${pad(agora.getHours())}${pad(agora.getMinutes())}${pad(agora.getSeconds())}_${pad(agora.getMilliseconds(), 3)}.html`;
    },

    criarArquivoTextoHtml(nomeGerado) {
      return new Blob([this.formData.htmlTexto], {
        type: "text/html;charset=utf-8",
      });
    },

    gerarNomeDownloadRelatorio(relatorio) {
      const nomeBase = (relatorio.titulo || relatorio.nome || "relatorio")
        .replace(/\.html?$/i, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[<>:"/\\|?*]/g, "")
        .split("")
        .filter((char) => char.charCodeAt(0) >= 32)
        .join("")
        .replace(/\s+/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_+|_+$/g, "");

      return `${nomeBase || "relatorio"}.html`;
    },

    limparVisualizacao() {
      clearIframePayloadSyncTimer(this, "reenvioDadosTimer", "reenvioDadosSequencia");
      this.carregamentoRelatorioToken += 1;
      this.selecionado = null;
      this.htmlAtual = "";
      this.iframeCarregado = false;
      this.iframeProntoParaDados = false;
      this.loadingHtml = false;
    },

    async carregarDadosSistema() {
      try {
        const res = await axios.get(`${urlApi}/analytics/dados`);
        this.jsonDados = res.data;
      } catch (err) {
        showError(err);
      }
    },

    async carregarListaRelatorios(nomeParaSelecionar = null) {
      this.loadingLista = true;

      try {
        const res = await axios.get(`${urlApi}/analytics/relatorios`);
        const listaBruta = res.data || [];

        const extraidos = await Promise.all(
          listaBruta.map(async (item) => {
            try {
              const htmlRes = await axios.get(`${urlApi}/analytics/relatorios/${item.nome}/conteudo`);
              const htmlStr = htmlRes.data;
              const parser = new DOMParser();
              const doc = parser.parseFromString(htmlStr, "text/html");
              const tituloTag = doc.querySelector("title");
              const titulo = tituloTag ? tituloTag.innerText : item.nome;
              return { ...item, titulo };
            } catch (e) {
              return { ...item, titulo: item.nome };
            }
          })
        );

        this.listaRelatorios = extraidos;

        const nomeAtual = nomeParaSelecionar || (this.selecionado && this.selecionado.nome);

        if (!nomeAtual) return;

        const relatorioAtual = this.listaRelatorios.find((item) => item.nome === nomeAtual);

        if (relatorioAtual) {
          await this.selecionarRelatorio(relatorioAtual);
        } else {
          this.limparVisualizacao();
        }
      } catch (err) {
        showError(err);
      } finally {
        this.loadingLista = false;
      }
    },

    async selecionarRelatorio(relatorio) {
      clearIframePayloadSyncTimer(this, "reenvioDadosTimer", "reenvioDadosSequencia");
      const carregamentoToken = ++this.carregamentoRelatorioToken;
      this.selecionado = relatorio;
      this.loadingHtml = true;

      try {
        const res = await axios.get(`${urlApi}/analytics/relatorios/${relatorio.nome}/conteudo`);
        if (carregamentoToken !== this.carregamentoRelatorioToken) return;

        if (res.data === this.htmlAtual) {
          this.agendarEnvioDadosParaIframe();
          return;
        }

        this.iframeCarregado = false;
        this.iframeProntoParaDados = false;
        this.iframeRenderToken += 1;
        this.htmlAtual = res.data;
      } catch (err) {
        showError(err);
      } finally {
        if (carregamentoToken === this.carregamentoRelatorioToken) {
          this.loadingHtml = false;
        }
      }
    },

    async baixarRelatorio(relatorio) {
      try {
        const html =
          this.selecionado && this.selecionado.nome === relatorio.nome && this.htmlAtual
            ? this.htmlAtual
            : (await axios.get(`${urlApi}/analytics/relatorios/${relatorio.nome}/conteudo`)).data;

        const blob = new Blob([html], { type: "text/html;charset=utf-8" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.gerarNomeDownloadRelatorio(relatorio);
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (err) {
        showError(err);
      }
    },

    onIframeLoad() {
      this.iframeCarregado = true;
      this.iframeProntoParaDados = false;
    },

    agendarEnvioDadosParaIframe() {
      scheduleIframePayloadSync(
        this,
        "reenvioDadosTimer",
        () => {
          this.enviarDadosParaIframe();
        },
        {
          tokenField: "reenvioDadosSequencia",
          iframeResolver: () => this.$refs.iframeRelatorio,
        }
      );
    },

    enviarDadosParaIframe() {
      const iframe = this.$refs.iframeRelatorio;

      if (
        !iframe
        || !iframe.contentWindow
        || !this.jsonDados
        || !this.htmlAtual
        || !this.iframeCarregado
        || !this.iframeProntoParaDados
      ) return;

      iframe.contentWindow.postMessage(
        {
          tipo: "pregao-dados",
          dados: this.jsonDados,
        },
        "*"
      );
    },

    handleWindowMessage(event) {
      const payload = event && event.data ? event.data : null;
      if (
        !payload
        || payload.tipo !== IFRAME_READY_MESSAGE_TYPE
        || payload.origem !== "painelAnalytics-viewer-ready"
      ) return;

      if (!this.$refs.iframeRelatorio || event.source !== this.$refs.iframeRelatorio.contentWindow) return;
      if (payload.token !== this.iframeRenderToken) return;

      this.iframeProntoParaDados = true;
      if (this.htmlAtual && this.jsonDados) {
        this.agendarEnvioDadosParaIframe();
      }
    },

    abrirDialogUpload() {
      this.uploadMode = "arquivo";
      this.formData = {
        arquivo: null,
        htmlTexto: "",
        isSubstituicao: false,
        nomeOriginal: "",
        tituloOriginal: "",
      };

      if (this.$refs.formUpload) this.$refs.formUpload.resetValidation();
      this.dialogUpload = true;
    },

    abrirDialogSubstituir(relatorio) {
      this.uploadMode = "arquivo";
      this.formData = {
        arquivo: null,
        htmlTexto: "",
        isSubstituicao: true,
        nomeOriginal: relatorio.nome,
        tituloOriginal: relatorio.titulo || relatorio.nome,
      };

      if (this.$refs.formUpload) this.$refs.formUpload.resetValidation();
      this.dialogUpload = true;
    },

    tratarSelecaoAbaIA(aba) {
      if (aba === 'ia') {
        if (this.$refs.formUpload) this.$refs.formUpload.resetValidation();
      }
    },

    async abrirChatIA() {
      // Fecha a dialog de upload/substituir para evitar janelas duplas
      this.dialogUpload = false;
      this.chatIAModo = this.formData.isSubstituicao ? 'editar' : 'criar';

      if (this.chatIAModo === 'editar') {
        this.chatIANomeOriginal = this.formData.nomeOriginal;
        this.chatIATituloRelatorio = this.formData.tituloOriginal;

        // Puxar o HTML do servidor
        try {
          const res = await axios.get(`${urlApi}/analytics/relatorios/${this.formData.nomeOriginal}/conteudo`);
          this.chatIAHtmlInicial = res.data;
          this.dialogChatIA = true;
        } catch (err) {
          showError(err, "Falha ao carregar conteúdo para edição");
        }
      } else {
        this.chatIAHtmlInicial = '';
        this.chatIATituloRelatorio = '';
        this.chatIANomeOriginal = '';
        this.dialogChatIA = true;
      }
    },

    async onChatIASalvo(nomeGerado) {
      await this.carregarListaRelatorios(nomeGerado);
    },

    async salvarUpload() {
      if (!this.$refs.formUpload.validate()) return;

      this.salvandoUpload = true;
      const nomeGerado = this.criarNomeInternoRelatorio();

      try {
        if (this.formData.isSubstituicao) {
          await axios.delete(`${urlApi}/analytics/relatorios/${this.formData.nomeOriginal}`);
        }

        const formDataForm = new FormData();
        const arquivoUpload =
          this.uploadMode === "arquivo"
            ? this.formData.arquivo
            : this.criarArquivoTextoHtml(nomeGerado);

        formDataForm.append("nome", nomeGerado);
        formDataForm.append("arquivo", arquivoUpload, nomeGerado);

        await axios.post(`${urlApi}/analytics/relatorios`, formDataForm, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$toasted.global.defaultSuccess({ msg: this.texts.toastSalvo });
        this.dialogUpload = false;
        await this.carregarListaRelatorios(nomeGerado);
      } catch (err) {
        showError(err);
      } finally {
        this.salvandoUpload = false;
      }
    },

    abrirDialogExcluir(relatorio) {
      this.relatorioParaExcluir = relatorio;
      this.dialogExcluir = true;
    },

    async confirmarExclusao() {
      if (!this.relatorioParaExcluir) return;

      this.excluindo = true;

      try {
        await axios.delete(`${urlApi}/analytics/relatorios/${this.relatorioParaExcluir.nome}`);
        this.$toasted.global.defaultSuccess({ msg: this.texts.toastExcluido });
        this.dialogExcluir = false;

        if (this.selecionado && this.selecionado.nome === this.relatorioParaExcluir.nome) {
          this.limparVisualizacao();
        }

        await this.carregarListaRelatorios();
      } catch (err) {
        showError(err);
      } finally {
        this.excluindo = false;
        this.relatorioParaExcluir = null;
      }
    },

    async baixarManual() {
      try {
        const manualContent = await fetchManualContent();
        if (!manualContent) {
          this.$toasted.global.defaultError({ msg: "Manual não disponível" });
          return;
        }
        const blob = new Blob([manualContent], { type: "text/markdown" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "manual-relatorios-pregao.md";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (err) {
        showError(err);
      }
    },
  },
};
</script>

<style scoped>
.analytics-container {
  background: #fcfcfc;
}

.analytics-container--fullscreen {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.analytics-row {
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  align-items: stretch;
}

.analytics-sidebar {
  border-right: 1px solid #d8e5e8;
  max-height: 80vh;
  min-height: 0;
  overflow: hidden;
  transition: padding 0.2s ease;
}

.analytics-container--fullscreen .analytics-sidebar {
  height: 100%;
  max-height: none;
}

.analytics-sidebar--collapsed {
  padding-left: 0 !important;
  padding-right: 0 !important;
  align-items: center;
}

.analytics-sidebar__header {
  min-height: 40px;
  width: 100%;
  flex: 0 0 auto;
  background: #fff;
  border-bottom: 1px solid #d8e5e8;
  padding-bottom: 12px;
}

.analytics-sidebar__content {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.analytics-sidebar__toggle-icon {
  transition: transform 0.2s ease;
}

.analytics-sidebar__toggle-icon--collapsed {
  transform: scaleX(-1);
}

.analytics-sidebar__toggle {
  margin-left: -4px;
  margin-right: 4px;
}

.analytics-sidebar--collapsed .analytics-sidebar__header {
  justify-content: center !important;
}

.analytics-sidebar--collapsed .analytics-sidebar__header>.d-flex.align-center {
  width: 100%;
  justify-content: center;
}

.analytics-sidebar--collapsed .analytics-sidebar__toggle {
  margin: 0 !important;
}

.analytics-sidebar__mini-list {
  width: 100%;
  align-items: center;
}

.analytics-sidebar__mini-item {
  border-radius: 12px;
}

.analytics-sidebar--collapsed .analytics-sidebar__mini-item,
.analytics-sidebar--collapsed .analytics-sidebar__toggle {
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
}

.analytics-sidebar__mini-item--selected {
  background: #e3f4f6;
}

.analytics-viewer {
  height: 80vh;
  min-height: 0;
  overflow: hidden;
  padding-left: 16px !important;
}

.analytics-container--fullscreen .analytics-viewer {
  height: 100%;
  flex: 1 1 auto;
}

.analytics-empty-state {
  flex: 1 1 auto;
  min-height: 0;
}

.analytics-empty-state__content {
  color: #666;
}

.analytics-frame-shell {
  position: relative;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.analytics-iframe {
  width: 100%;
  height: 100%;
  display: block;
  border: 1px solid #d8e5e8;
  border-radius: 8px;
  background: #fff;
}

.analytics-dialog__title,
.color-primary {
  color: #0b7285 !important;
}

.analytics-upload-toggle {
  display: inline-flex;
}

.loading-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.selected-item {
  background-color: #e3f4f6 !important;
  border-left: 4px solid #0b7285;
}

.selected-item .v-list-item__title {
  color: #0b7285;
  font-weight: bold;
}

@media (max-width: 959px) {
  .analytics-sidebar {
    border-right: 0;
    max-height: none;
  }

  .analytics-sidebar__header {
    border-bottom: 0;
    padding-bottom: 0;
  }

  .analytics-sidebar__content {
    overflow: visible;
  }

  .analytics-viewer {
    height: auto;
    min-height: 60vh;
    padding-left: 0 !important;
    padding-top: 16px !important;
  }

  .analytics-frame-shell {
    min-height: 60vh;
  }
}
</style>
